import React from 'react';
import { Link } from 'react-router-dom';

import CSS from './AuthErrors.module.scss';

type AuthErrorCode =
  | 'EmailCreateAccount'
  | 'CredentialsSignin'
  | 'NoCredentialsProvided'
  | 'AlreadyExists';

const messages: Record<AuthErrorCode | 'default', string> = {
  EmailCreateAccount:
    'Could not create this account. Please revisit your details or reset your password if your email is already registered.',
  CredentialsSignin: 'Invalid email or password. Please try again.',
  NoCredentialsProvided: 'No credentials provided. Please try again.',
  AlreadyExists: 'This email is already registered. Try signing in instead.',
  default: 'An error occurred. Please try again.',
};

const errorMessages = {
  getString(code: AuthErrorCode | string | null | undefined): string {
    if (!code) {
      return '';
    }
    return messages[code as AuthErrorCode] || messages.default;
  },

  get(code: AuthErrorCode | string | null | undefined): React.ReactNode {
    if (!code) {
      return null;
    }

    if (code === 'AlreadyExists') {
      return (
        <>
          This email is already registered.{' '}
          <Link to="/login" className={CSS.Link} replace>
            Try to log in instead.
          </Link>
        </>
      );
    }

    return messages[code as AuthErrorCode] || messages.default;
  },
};

export default errorMessages;
